import { ISolutionsMenuItem } from "./MenuOptionsHelpers";

export const NavigationReducer = (state: any, action: any) => {
  if (action.type === "collapse") {
    return {
      ...state,
      solutions: closeSolutions(state.solutions),
      openFooterMenu: null,
      isExpanded: false,
    };
  }

  if (action.type === "expand") {
    return {
      ...state,
      isExpanded: true,
    };
  }

  if (action.type === "assign") {
    return {
      ...state,
      solutions: action.solutions,
    };
  }

  if (action.type === "select_solution") {
    return {
      ...state,
      isExpanded: true,
      openFooterMenu: null,
    };
  }

  if (action.type === "select_capability") {
    if (action.goTo) action.goTo();
    return {
      ...state,
      solutions: closeSolutions(state.solutions),
      isExpanded: false,
      openFooterMenu: null,
    };
  }

  if (action.type === "open_footer") {
    return {
      ...state,
      solutions: closeSolutions(state.solutions),
      isExpanded: true,
      openFooterMenu: action.footerMenu,
    };
  }

  if (action.type === "close_footer") {
    return {
      ...state,
      openFooterMenu: null,
    };
  }

  if (action.type === "tile_click") {
    return {
      ...state,
      solutions: openSolution(state.solutions, action.solutionId),
      isExpanded: true,
      openFooterMenu: null,
    };
  }

  throw Error("Unknown action.");
};

function closeSolutions(solutions: ISolutionsMenuItem[]): ISolutionsMenuItem[] {
  const closed = solutions.map((solution: ISolutionsMenuItem) => {
    solution.expanded = false;
    return solution;
  });

  return closed;
}

function openSolution(
  solutions: ISolutionsMenuItem[],
  openSolutionId: string
): ISolutionsMenuItem[] {
  return solutions.map((solution: ISolutionsMenuItem) => {
    solution.label === openSolutionId
      ? (solution.expanded = true)
      : (solution.expanded = false);
    return solution;
  });
}
